
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/predlagaj-idejo",
      function () {
        return require("private-next-pages/predlagaj-idejo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/predlagaj-idejo"])
      });
    }
  